<template>
  <section>
    <v-card>

      <v-row dense class="pa-2 align-center">

      <v-col cols="6">
        <v-btn color="primary" class="vBtn vIconResize mgr" @click="dialogProducts = true" :dark="presentId && presentId !== null"  :disabled="!presentId">
          <v-icon class="mr-2">mdi mdi-playlist-plus</v-icon>
          제품 추가</v-btn>
      </v-col>

      <v-col cols="6" class="d-flex text-right align-center">
        <v-text-field
          v-model="searchQuery"
          append-icon="mdi-magnify"
          solo
          rounded
          hide-details
          dense
          clearable
          placeholder="검색"
        ></v-text-field>
        <v-btn
          icon
          small
          class="ml-2"
          @click="searchQuery = null"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

      </v-col>

    </v-row>

      <v-data-table
      :headers="headers"
      :items="products"
      class="flex-grow-1"
      item-key="productId"
      :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100,-1]}"
      :search="searchQuery"
    >
      <template v-slot:item.quantity="props">
        <v-edit-dialog
            :return-value.sync="props.item.quantity"
            large
            persistent
        >
          <div class="ml-1 caption font-weight-bold text-decoration-underline" style="color: #1867c0" v-if="props.item.quantity">{{ props.item.quantity | numeralFormat('0,000') }}</div>
          <div class="ml-1 caption font-weight-bold text-decoration-underline" style="color: #1867c0" v-else>무제한</div>
          <template v-slot:input>
            <v-text-field
                v-model="props.item.quantity"
                type="number"
                label="준비수량"
                single-line
                counter
                autofocus
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>

      <template v-slot:item.category="{ value }">
        {{value.categoryName}}
      </template>

      <template v-slot:item.price="{ value }">
        {{value | numeralFormat('0,000')}}
      </template>

      <template v-slot:item.createdAt="{ value }">
<!--        <div>{{ value | moment('YYYY-MM-DD HH:mm:ss') }}</div>-->
        <div>{{ value | moment('YYYY-MM-DD') }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn color="orange" @click.prevent.stop="deleteProduct(item)" dark small>
          <v-icon
              small
              class="mr-2"
          >
            mdi-delete
          </v-icon>
          삭제
        </v-btn>

<!--        <v-icon-->
<!--            small-->
<!--            @click.prevent.stop="deleteProduct(item)"-->
<!--        >-->
<!--          mdi-delete-->
<!--        </v-icon>-->
      </template>

    </v-data-table>


    </v-card>
    <v-dialog
        v-model="dialogProducts"
        persistent
        max-width="1000px"
        @click:outside="dialogProducts = false" @keydown.esc="dialogProducts = false"
    >
      <v-card>
        <v-card-title>
          <span class="headline">제품 목록</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <product-list @product-selected="addProduct" :selected-product="products.map(p => p.product)"></product-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="dialogProducts = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="btnStyleBx">
      <div class="btnCommon justify-center">
        <v-btn color="success" @click="saveProducts" :dark="presentId && presentId !== null" :disabled="!presentId">
          <v-icon left>mdi mdi-content-save</v-icon>
          제품 저장
        </v-btn>
      </div>
    </div>

  </section>
</template>

<script>
import PresentApi from "@/api/PresentApi"
import ProductList from '../../product/components/List'

export default {
  components: {
    ProductList
  },
  props: {
    presentId: String
  },
  data() {
    return {
      dialogProducts: false,
      searchQuery: '',
      headers: [
        // { text: 'Id', align: 'left', value: 'productId' },
        { text: '분류', align: 'left', value: 'product.category.categoryName' },
        { text: '제품명', align: 'left', value: 'product.productName' },
        // { text: '소비자가격', value: 'price' },
        { text: '준비수량', value: 'quantity' },
        { text: '주문수량', value: 'orderCount' },
        { text: '추가일', value: 'createdAt' },
        { text: '삭제', sortable: false, value: 'actions' }
      ],
      param:{},
      totalItems: 0,
      products: [],
    }
  },
  mounted() {
  },
  methods: {
    deleteProduct(product) {
      if(product.orderCount > 0) {
          alert("접수된 신청건이 있습니다.")
          return
      }
      if(confirm("삭제하시겠습니까?")) {
        this.products = this.products.filter(p => p.productId !== product.productId)
      }
    },
    addProduct(p) {
      if(this.products.some(pp => pp.product.productId === p.productId)) {
        alert('이미 추가된 제품입니다.');
        return;
      }
      this.products.push({
        product: p,
        quantity: 0,
        orderCount: null,
        productId: p.productId
      })
      this.dialogProducts = false;
    },
    getProducts() {
      PresentApi.productList(this.presentId).then(data => {
        this.products = data;
      })
    },
    saveProducts() {
      PresentApi.saveProducts(this.presentId, this.products).then(data => {
        alert('저장되었습니다.');
        this.products = data;
      })
    }

  },
  created() {
    if(this.presentId)
      this.getProducts()
  }
}
</script>